import { InjectionToken } from '@angular/core';

import { SnackbarData } from './snack-bar-data.type';

export const SNACK_BAR_DATA = new InjectionToken<SnackbarData>('Snack Bar Data');
